import { Grid2 } from "@mui/material"

export default function ScheduleButton({...params}){

    let pageMode = params.pageMode
    let setPageMode = params.setPageMode

    const togglePageMode = () => {
        if (pageMode === 'read') setPageMode('schedule')
        else if (pageMode === 'edit' || pageMode === 'schedule') return
    }

    return (
        <>

            <Grid2>
                <button onClick={togglePageMode}>Broadcast Schedule</button>
            </Grid2>
            
        </>
    )
}
